// Private comparison page — visit /brand-concept to review both logo variants.
// Not linked in the main navigation.
import { Link } from 'react-router-dom';

const OPTIONS = [
  {
    id: 'current',
    label: 'Current · Official',
    subtitle: 'Gold + Silver metallic mark',
    src: '/brand/alpha-tex-mark-transparent.png',
    note: 'Warm, premium, luxury-craft feel. This is your saved official version.',
    tagBg: 'bg-[#1D4ED8]',
  },
  {
    id: 'concept',
    label: 'Concept · Black + Silver',
    subtitle: 'Local San Antonio palette',
    src: '/brand/alpha-tex-mark-silver.png',
    note: 'Cool, industrial, hometown pride. Same shape, same feel — just a colder metallic.',
    tagBg: 'bg-[#0A0A0A]',
  },
];

function Card({ opt }) {
  return (
    <div className="relative border border-black/10 bg-white p-8 md:p-12 flex flex-col">
      <div className={`absolute -top-3 left-8 px-3 py-1 font-mono-label text-[10px] tracking-[0.24em] uppercase text-white ${opt.tagBg}`}>
        {opt.label}
      </div>
      <div className="font-mono-label text-[10px] tracking-[0.24em] uppercase text-[#0A0A0A]/55 mb-8 mt-2">
        {opt.subtitle}
      </div>

      {/* Preview on light card */}
      <div className="grid grid-cols-2 gap-6 mb-8">
        <div className="aspect-square border border-black/10 bg-white grid place-items-center p-6">
          <img src={opt.src} alt={`${opt.label} on white`} className="max-h-full max-w-full object-contain" />
        </div>
        <div className="aspect-square border border-black/10 bg-[#0A0A0A] grid place-items-center p-6">
          <img src={opt.src} alt={`${opt.label} on dark`} className="max-h-full max-w-full object-contain" />
        </div>
      </div>

      {/* Lockup preview */}
      <div className="border border-black/10 p-6 flex items-center gap-4 mb-6">
        <img src={opt.src} alt="" className="w-14 h-14 object-contain" />
        <div className="leading-[0.95]">
          <div className="font-display uppercase tracking-tight text-2xl text-[#0A0A0A]">ALPHA TEX</div>
          <div className="font-mono-label text-[10px] tracking-[0.28em] uppercase text-[#0A0A0A]/55 mt-1 flex items-center gap-1.5">
            <span>Construction · Remodel</span>
            <span className="w-1 h-1 rounded-full bg-[#DC2626]" />
            <span className="text-[#1D4ED8]">Est. 2023</span>
          </div>
        </div>
      </div>

      <p className="text-[#0A0A0A]/70 text-sm leading-relaxed">{opt.note}</p>
    </div>
  );
}

export default function BrandConcept() {
  return (
    <div className="min-h-screen bg-[#FAFAF5] pt-32 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <div className="font-mono-label text-[10px] tracking-[0.28em] uppercase text-[#DC2626] mb-4">// Brand · Concept preview</div>
          <h1 className="font-display uppercase text-[#0A0A0A] text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-3xl">
            Two versions.<br />Same logo.
          </h1>
          <p className="mt-6 text-[#0A0A0A]/70 max-w-2xl">
            Left is your saved official mark. Right is a black + silver concept — a nod to San Antonio's colors and a colder, more industrial read for the same shape. Nothing on the live site has changed. Pick one and I'll roll it out everywhere.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-10">
          {OPTIONS.map((o) => <Card key={o.id} opt={o} />)}
        </div>

        <div className="mt-16 flex items-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-3 border border-black/15 text-[#0A0A0A] px-6 py-3 font-mono-label text-[11px] tracking-[0.24em] uppercase hover:bg-black/5"
          >
            ← Back to site
          </Link>
        </div>
      </div>
    </div>
  );
}
